import styled from "styled-components";
import { useState, useEffect } from "react";
import { Button, Checkbox, Input } from "antd";
import { IoFilter } from "react-icons/io5";

const InputSearch = styled.div`
  width: 100%;
  .input-search__container {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    color: #6e6893;
    input {
      width: 20vw;
      background-color: #f4f2ff;
      border: none;
      font-size: 1vw;
      border-radius: 5px;

      @media only screen and (max-width: 768px) {
        width: 200px;
        font-size: 16px;
        height: 40px;
      }

      @media only screen and (max-width: 450px) {
        width: 250px;
        font-size: 14px;
        height: 40px;
      }

      @media only screen and (max-width: 376px) {
        width: 150px;
        font-size: 14px;
        height: 40px;
      }

      @media only screen and (min-width: 1200px) {
        width: 300px;
        font-size: 14px;
        height: 40px;
      }
    }
    input::placeholder {
      color: #6e6893;
      font-size: 16px;

      @media only screen and (max-width: 768px) {
        width: 200px;
        font-size: 16px;
        height: 40px;
      }

      @media only screen and (max-width: 450px) {
        width: 250px;
        font-size: 14px;
        height: 40px;
      }

      @media only screen and (max-width: 376px) {
        width: 150px;
        font-size: 14px;
        height: 40px;
      }

      @media only screen and (min-width: 1200px) {
        width: 300px;
        font-size: 14px;
      }
    }
  }
`;

const FilterSearch = styled.div`
  position: relative;
  margin-right: 5px;
  .search__filter-button {
    height: 100%;
    border-radius: 5px;
  }

  .search__filter-popup {
    border: 1px solid gray;
    position: absolute;
    z-index: 9;
    background-color: #fff;
    padding: 5px 10px;
    top: 0px;
    left: 100%;
    white-space: nowrap;
    flex-direction: column;
    display: ${(props) => (props.isOpen ? "flex" : "none")};
    > * {
      margin: 0px;
    }

    .filter-popup__button-group {
      display: flex;
      margin-top: 5px;
      justify-content: center;
    }

    input {
      width: 100%;
    }
  }
`;

export default function Search(props) {
  const [toggleFilterPopup, setToggleFilterPopup] = useState(false);

  useEffect(() => {
    if (!props.allowSearch && props.columns.length > 0){
      props.setAllowSearch( props.columns.map((c) =>c.className.indexOf("allow-search") >= 0 ? c.dataIndex : null).filter((i) => i !== null));
    }
  }, [props.columns, props.allowSearch]);

  return (
    <InputSearch className="input-search">
      <div className="input-search__container">
        <FilterSearch className="search__filter" isOpen={toggleFilterPopup}>
          <Button
            className="search__filter-button btn-secondary"
            onClick={() => {
              // setToggleFilterPopup(!toggleFilterPopup);
            }}
          >
            <IoFilter />
          </Button>
          <div className="search__filter-popup">
            {props.columns.map(
              (c) =>
                c.className.indexOf("allow-search") >= 0 && (
                  <Checkbox
                    key={c.dataIndex}
                    value={c.dataIndex}
                    checked={
                      props.allowSearch &&
                      props.allowSearch.indexOf(c.dataIndex) >= 0
                        ? true
                        : false
                    }
                    onChange={(e) => {
                      if (!e.target.checked) {
                        props.setAllowSearch(
                          props.allowSearch.filter((i) => i != e.target.value)
                        );
                      } else {
                        props.setAllowSearch([
                          ...props.allowSearch,
                          e.target.value,
                        ]);
                      }
                    }}
                  >
                    {c.title}
                  </Checkbox>
                )
            )}
            <div className="filter-popup__button-group">
              <Button
                className="btn-primary"
                onClick={() => {
                  setToggleFilterPopup(false);
                }}
              >
                ปิด
              </Button>
            </div>
          </div>
        </FilterSearch>
        <Input
          className="search__input"
          placeholder="ค้นหาในตาราง"
          onChange={props.filterByValue}
        />
      </div>
    </InputSearch>
  );
}
